export const BACKGROUND_FADE_DURATION = 0.1;
export const MENU_OPEN_DURATION = 0.5;
export const MENU_CONTENT_DURATION = 0.5;
export const MENU_CLOSE_DURATION = 0.5;
export const SUB_MENU_DURATION = 0.3;
export const BUTTON_DURATION_PART_1 = 0.1;
export const BUTTON_DURATION_PART_2 = 0.2;
export const BUTTON_DURATION = BUTTON_DURATION_PART_1 + BUTTON_DURATION_PART_2;
